














































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import OffersService from '@/api/OffersService';
import CoinsService from '@/api/CoinsService';
import eventBus from '@/utils/eventBus.js';
import { Pagination, SortController } from '@/utils/Pagination';
import DateUtils from '@/utils/DateUtils';
import { pluralize } from '@/utils';

import { HeaderList } from '@/components/Table/TableModel';
import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import ModalOptions from '@/components/Modal/ModalOptions';
import Typography from '@/components/atoms/Typography/Typography.vue';
import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import ResumeCard from '@/componentsV2/molecules/ResumeCard/ResumeCard.vue';
import AwardCoinsIconIcon from '@/components/icons/AwardCoins.vue';
import SendOfferIcon from '@/components/icons/SendOffer.vue';
import TableCard from '@/componentsV2/molecules/TableCard/TableCard.vue';

@Component({
  components: {
    SideModalHeader,
    Table,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    Typography,
    ResumeCard,
    AwardCoinsIconIcon,
    SendOfferIcon,
    TableCard
  }
})
export default class CustomerDetail extends Vue {
  @Prop({ required: true }) data!: any;
  preview: boolean = false;
  infoToSendCoins: any = {};
  OffersService: OffersService = new OffersService();
  CoinsService: CoinsService = new CoinsService();
  infoToSendOffer: any = {};
  amountCoins = this.data.coins || 0;

  pagination = new Pagination(this.formatRow);
  sort = new SortController();
  query: any = {};
  loading = false;

  headers = [
    new HeaderList(`Date`, 'none', '6px 16px'),
    new HeaderList(`Activity`, 'none', '6px 8px'),
    new HeaderList(`Time`, 'none', '6px 8px')
  ];

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  updateSort(field: string) {
    this.sort.update(field);
    this.query = {
      ...this.query,
      sort: this.sort.toString()
    };
  }

  @Watch('pagination.loading')
  onPaginationLoading(value: boolean) {
    this.loading = value;
  }

  @Watch('query')
  refreshPagination(query: any) {
    this.pagination.refresh(`/activity/${this.data.id}`, query);
  }

  created() {
    this.bindEvents();
    this.refreshPagination(this.query);
  }

  mounted() {
    this.pagination.setPaginationTarget(this.$refs.target as HTMLElement);
  }

  formatRow(row: any) {
    return {
      message: row.message,
      date: DateUtils.formatISODate(row.createdAt),
      time: DateUtils.timeConvert(
        DateUtils.getLocalDateISOString(row.createdAt)
          .split('T')[1]
          .replace(/:\d\d.\d\d\dZ/gi, '')
      )
    };
  }

  get getPicture() {
    try {
      if (!this.data.picture.includes('https')) return '';
      return {
        background: `url('${this.data.picture}')`,
        backgroundSize: 'cover'
      };
    } catch (e) {
      return 'hasNoImage';
    }
  }

  formatDate(date: string) {
    return DateUtils.formatISODate(date);
  }

  beforeDestroy() {
    this.unBindEvents();
  }

  sendCoinsModal() {
    this.openSubModal('sendCoinsModal');
  }

  sendOfferModal() {
    this.openSubModal('sendOfferModal');
  }

  openSubModal(component: string) {
    this.preview = this.isMobileDevice ? true : !this.preview;

    const modalConfig = {
      isOpen: true,
      component: 'customerDetails',
      disabledBackdropClick: true,
      data: this.data,
      secondaryStyle: true,
      subModal: {
        isOpen: this.preview,
        component
      }
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  closeSubModal() {
    this.preview = !this.preview;
    const modalConfig = {
      isOpen: true,
      component: 'customerDetails',
      data: this.data,
      isSecondary: true,
      subModal: {
        isOpen: false
      }
    };

    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  bindEvents() {
    eventBus.$on('sendCoin', this.sendCoin);
    eventBus.$on('sendOffer', this.sendOffer);
    eventBus.$on('sendCoinConfirm', this.sendCoinConfirm);
    eventBus.$on('sendOfferConfirm', this.sendOfferConfirm);
  }

  sendCoin(data: any) {
    this.infoToSendCoins = data;
    eventBus.$emit(
      'openModal',
      new ModalOptions(
        `Award Coins`,
        `
         You are about to send <b> ${data.coins} </<b> ${pluralize(
          data.coins,
          'Coin'
        )} to
        <b>${this.data.name}</b>

         Would you like to proceed?`,
        'award',
        false,
        `Yes`,
        `No`,
        'sendCoinConfirm'
      )
    );
  }

  sendOffer(data: any) {
    this.infoToSendOffer = data;
    eventBus.$emit(
      'openModal',
      new ModalOptions(
        `Send Offer`,
        `
        You are about to send the offer <b>${data.offer.label}</b> to
        <b>${this.data.name}</b>
        Would you like to proceed?`,
        'send-offer',
        false,
        `Yes`,
        `No`,
        'sendOfferConfirm'
      )
    );
  }

  sendOfferConfirm(confirm: boolean) {
    if (!confirm) {
      setTimeout(() => {
        this.closeSubModal();
      }, 400);
      return;
    }
    const offerId = this.infoToSendOffer.offer.uuid;
    const data = {
      message: this.infoToSendOffer.message,
      customersIds: [this.data.id]
    };
    this.OffersService.sendOffer(offerId, data).then(res => {
      if (res && res.status === 200) {
        this.closeSubModal();
        eventBus.$emit('reloadCustomers', true, true);
        this.$notification(
          `${this.infoToSendOffer.offer.label} offer has been sent to ${
            this.data.name
          }`
        );
      }
    });
  }

  sendCoinConfirm(confirm: boolean) {
    if (!confirm) {
      setTimeout(() => {
        this.closeSubModal();
      }, 400);
      return;
    }
    const data = {
      ...this.infoToSendCoins,
      coins: Number(this.infoToSendCoins.coins),
      customerId: this.data.id
    };
    this.CoinsService.sendCoins(data).then(res => {
      if (res && res.status === 201) {
        this.amountCoins =
          Number(this.amountCoins) + Number(this.infoToSendCoins.coins);

        this.closeSubModal();
        setTimeout(() => {
          eventBus.$emit('reloadCustomers', true, true);
          eventBus.$emit('reloadCampaignCustomers', true, true);
          eventBus.$emit('reloadHomeCustomerList');
        }, 200);
        this.$notification(
          `An award of ${pluralize(
            this.infoToSendCoins.coins,
            'Coin'
          )} has been sent to ${this.data.name}`
        );
      }
    });
  }

  unBindEvents() {
    eventBus.$off('sendCoin');
    eventBus.$off('sendOffer');
    eventBus.$off('sendCoinConfirm');
    eventBus.$off('sendOfferConfirm');
  }
}
